// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  effectId: __t.u64().primaryKey().name("effect_id"),
  source: __t.identity(),
  target: __t.identity(),
  systemId: __t.string().name("system_id"),
  sourceShipId: __t.u64().name("source_ship_id"),
  targetShipId: __t.u64().name("target_ship_id"),
  sourceSeq: __t.u32().name("source_seq"),
  targetSeq: __t.u32().name("target_seq"),
  requestId: __t.string().name("request_id"),
  capSpent: __t.u32().name("cap_spent"),
  strength: __t.f64(),
  startedAt: __t.timestamp().name("started_at"),
  expiresAt: __t.timestamp().name("expires_at"),
  state: __t.string(),
  endedAt: __t.timestamp().name("ended_at"),
  endReason: __t.string().name("end_reason"),
  farSince: __t.timestamp().name("far_since"),
  sepM: __t.f64().name("sep_m"),
  updatedAt: __t.timestamp().name("updated_at"),
});
